module.exports = __webpack_public_path__ + "img/AssignedUsers.292c3a0e.svg";